import { render, staticRenderFns } from "./bg_extension.vue?vue&type=template&id=09511773&scoped=true&"
import script from "./bg_extension.vue?vue&type=script&lang=js&"
export * from "./bg_extension.vue?vue&type=script&lang=js&"
import style0 from "./bg_extension.vue?vue&type=style&index=0&id=09511773&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09511773",
  null
  
)

export default component.exports